import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import { SelectedIcon } from "../../menu-list-item/MenuListItem.styled";
import * as Styled from "./Select.styled";
import { stringMapDefault } from "./Select.stringMap";
import { SelectLabel } from "./SelectLabel";
export const SelectOption = forwardRef((props, ref) => {
    const { depth = 1, description, disabled, groupLabel, hasChildren, isHighlighted, isNested, isSearchable, isSelected, label, labelString, onClick, onSelect, parentId, searchText, stringMap: stringMapProp, value, 
    // deprecated, unused
    onIconClick, onNextClick, closeAndReturnFocus, isOpen, overlayRef, setIsOpen, ...otherProps } = props;
    const stringMap = useStringMap("Select", { stringMapDefault, stringMapProp });
    const handleClick = (event) => {
        hasChildren && event.stopPropagation();
        label &&
            value !== undefined &&
            !disabled &&
            onClick &&
            onClick({ value, label, labelString, onSelect, ...otherProps }, onSelect);
    };
    const handleKeyDown = (event) => {
        if (hasChildren && event.key === "ArrowRight") {
            handleClick(event);
        }
    };
    if (label) {
        const labelToRender = typeof label === "function" ? label({ searchText }) : label;
        return (_jsxs(Styled.OptionItem, { ref: ref, tabIndex: -1, "aria-disabled": disabled, "aria-selected": isSelected, "data-id": parentId, "data-label": typeof label === "string" ? label : labelString || "none", "data-select-item": true, "data-testid": "SelectOption", onClick: handleClick, onKeyDown: handleKeyDown, depth: depth, isDisabled: disabled, isHighlighted: isHighlighted, isNested: isNested, isSearchable: isSearchable, isSelected: isSelected, ...otherProps, children: [_jsx(SelectedIcon, { size: 16, isSelected: isSelected, palette: "interactiveConstructive", "aria-hidden": true }), _jsx(SelectLabel, { groupLabel: groupLabel, label: labelToRender, labelId: `${parentId}-label`, description: description }), hasChildren && _jsx(Styled.ForwardIcon, { "aria-label": stringMap.viewNested })] }));
    }
    return _jsx(Styled.OptionItem, { ref: ref, role: "none", "data-testid": "SelectOption" });
});
SelectOption.displayName = "SelectOption";
